module.exports = "/_next/static/images/clean-up-vector-cafa2b9e7577233580f30c9209a901cd.svg";